import React from 'react'
import CircleIcon from '@mui/icons-material/Circle';
import { Link } from 'react-router-dom';

const MemberCard = ({item}) => {
  return (

  <Link to={`/member/${item?._id}`} className='projects__card dashcard'> 
    <div className='membercards1'>
          <img className='membercards1-img' src={item?.profilePic} alt='Profile-pic'/>
          <CircleIcon className='membercards1-img-icon' sx={{color: item?.status==="Active"?"#16a34a":"red"}}/>
    </div>
    <div className='projects__content membercards2'>
             <h2 className="projects__title">{item?.name}</h2>
               <h3 className="projects__subtitle">{"+91"+ item?.mobileNo}</h3>
              <p className="projects__description">Next Bill Date : {item?.nextBillDate.slice(0,10).split("-").reverse().join("-")}</p>
    </div>
  </Link>
  
  )
}

export default MemberCard
